export const BAD_OPEN_END = 'bad-openend';
export const EXIT_CONDITION = 'exit-condition';
export const UNKNOWN = 'unknown';
export const SESSION_LENGTH = 'session-length';
export const SPEED = 'speed';
export const SCREENSHOT = 'screenshot';
export const INVALID_USER_PROFILE = 'invalid_user_profile';
export const QUOTA_PATHED_QUESTION = 'quotaPathedQuestion';
export const CONDITIONAL_LOGIC = 'conditionalLogic';
export const INVALID_ACTION = 'invalid_action';
export const ADMIN_REJECT = 'admin-reject';
export const STALLED = 'stalled';
export const AID_TERMINATION_LIST = 'termination-list';

export const BAD_RESPONDANT = 'BAD_RESPONDANT'; // Deprecated - this is not a reason, but the category



// WEBPACK FOOTER //
// ./src/constants/screenReasons.js